import SectionNavButton from '../atoms/SectionNavButton';
import { SectionNavBarButtonOptions } from '../atoms/SectionNavButton.types';

type Properties = {
    leftButtonOptions?: SectionNavBarButtonOptions;
    rightButtonOptions?: SectionNavBarButtonOptions;
};

const SectionNavButtonsBar = (props: Properties) => {
    let leftButton = <></>;
    if (props.leftButtonOptions !== undefined) {
        leftButton = (
            <SectionNavButton
                text={props.leftButtonOptions.text}
                onClick={props.leftButtonOptions.onClick}
                disabled={props.leftButtonOptions.disabled}
                btnClass={'button-previous swiper-no-swiping'}
            />
        );
    }

    let rightButton = <></>;
    if (props.rightButtonOptions !== undefined) {
        rightButton = (
            <SectionNavButton
                text={props.rightButtonOptions.text}
                onClick={props.rightButtonOptions.onClick}
                disabled={props.rightButtonOptions.disabled}
                btnClass={'button-next swiper-no-swiping'}
            />
        );
    }

    return (
        <div className="menu-bot">
            {leftButton}
            {rightButton}
        </div>
    );
};

export default SectionNavButtonsBar;
